export default "__VITE_ASSET__fe9cc028__"